import { getHorizontalBarBackgroundStyle2, ValuedColorsProvider } from "@omnia/shared/color/provider"
import { defineDirective, isNumber } from "../../omnia"
import { getNutrientColorProvider } from "@omnia/shared/nutrition/colors"

export class NumbarCtrl {

    static create(): ng.IDirective {

        const def = defineDirective(NumbarCtrl, undefined)

        def.template = `<div ng-if='vm.hasValue'>
            <div class='v'>{{vm.text}}</div>
            <div class='b' ng-style='vm.style'>
            </div>
            </div>`

        def.scope = {
            "value": "<",
            "nutrient": "<",
        }

        return def

    }

    private _value: any
    private _nutrient: string

    public text: string
    public hasValue: boolean

    private readonly state = {
        provider: undefined as ValuedColorsProvider,
        nutrient: undefined as string,
        value: undefined,
        style: undefined
    }

    public style: any

    get value() {
        return this._value
    }

    set value(value: any) {

        this._value = value

        const hasValue = this.hasValue = isNumber(value)
        this.text = hasValue ? value.toString() : undefined
        this.updateStyle()

    }

    get nutrient() {
        return this._nutrient
    }

    set nutrient(value) {
        this._nutrient = value
        this.updateStyle()
    }

    updateStyle() {

        const { state: style, nutrient, value } = this

        if (style.nutrient != nutrient) {

            style.style = undefined
            style.provider = undefined

            if (nutrient) {
                style.provider = getNutrientColorProvider(this.nutrient)
            }

        }

        if (style.value !== value) {
            style.style = undefined
        }

        const { provider } = style

        if (provider && (!style.style)) {

            const values = [{ value: this.value, color: provider.getReferenceColor() }]

            this.style = style.style = getHorizontalBarBackgroundStyle2(values, provider.getMinValue(), provider.getMaxValue())

        }

        return style.style

    }
}
